module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_3.aa66b408.png";